import { getTrndsProductGroups } from '@round/api';
import { NavBarItem, getNavBarItems } from './helpers';

const NAVBAR_ITEMS: NavBarItem[] = getNavBarItems([
    {
        title: 'Explore',
        items: [
            {
                title: 'Tiktok Audios',
                groups: getTrndsProductGroups(['explorer_tiktok_viewer']),
                url: '/explorer/tiktok/audio/',
            },
            {
                title: 'Instagram Audios',
                groups: getTrndsProductGroups(['explorer_instagram_viewer']),
                url: '/explorer/instagram/audio/',
            },
            {
                title: 'Trending Audios',
                groups: getTrndsProductGroups(['user_admin']),
                url: '/explorer/tiktok/trending-audios/',
            },
            {
                title: 'Songs',
                groups: getTrndsProductGroups([]),
                url: '/explorer/songs/',
            },
        ],
    },
    {
        title: 'Collections',
        items: [
            {
                title: 'Tiktok Audios',
                groups: getTrndsProductGroups(['catalogue_viewer']),
                url: '/collections/tiktok/',
            },
            {
                title: 'Songs',
                groups: getTrndsProductGroups([]),
                url: '/collections/songs/',
            },
        ],
    },
    {
        title: 'Detect',
        items: [
            {
                title: 'Songs',
                groups: getTrndsProductGroups(['user_admin']),
                url: '/detect/songs/',
            },
            {
                title: 'Trending Audios',
                groups: getTrndsProductGroups(['user_admin']),
                url: '/detect/tiktok/trending-audios/',
            },
        ],
    },
    {
        title: 'Admin',
        items: [
            {
                title: 'Artists',
                groups: getTrndsProductGroups(['user_admin']),
                url: '/admin/artist/',
            },
            {
                title: 'Songs',
                groups: getTrndsProductGroups(['user_admin']),
                url: '/admin/song/',
            },
            {
                title: 'Data Download',
                groups: getTrndsProductGroups(['trnds_admin']),
                url: '/admin/data-download/',
            },
        ],
    },
    {
        title: 'Client',
        items: [
            {
                title: 'Song Explore',
                groups: getTrndsProductGroups(['trnds_admin']),
                url: '/client/explorer/songs/',
            },
            {
                title: 'Tiktok Audios',
                groups: getTrndsProductGroups(['trnds_admin']),
                url: '/client/explorer/tiktok/audio/',
            },
            {
                title: 'Song Collections',
                groups: getTrndsProductGroups(['trnds_admin']),
                url: '/client/collections/songs/',
            },
        ],
    },
]);

const CLIENT_NAVBAR_ITEMS: NavBarItem[] = getNavBarItems([
    {
        title: 'Explore',
        items: [
            {
                title: 'Songs',
                groups: ['trnds_client'],
                url: '/client/explorer/songs/',
            },
            {
                title: 'Tiktok Audios',
                groups: ['trnds_client'],
                url: '/client/explorer/tiktok/audio/',
            },
        ],
    },
    {
        title: 'Collections',
        items: [
            {
                title: 'Songs',
                groups: ['trnds_client'],
                url: '/client/collections/songs/',
            },
        ],
    },
]);

export { NAVBAR_ITEMS, CLIENT_NAVBAR_ITEMS };
